import React from "react";
import constants from "../constants";

export default function AngleRightSvg(Props) {  
  const color = Props.sql? "#667085" : "#E54B2A" ;
  return Props.type === 1 ? (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className="angleRightSvgIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={color}
        d="M6 12L10 8L6 4"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : Props.component === "codingTable" ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className="codingTableLeftSvgIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={
          Props.status === constants.PROGRESS_STATUS.UNLOCKED
            ? "#12B76A"
            : Props.status === constants.PROGRESS_STATUS.LOCKED
            ? "#EAECF0"
            : Props.status === constants.PROGRESS_STATUS.QN_CONTINUE
            ? "#E54B2A"
            : Props.status === constants.PROGRESS_STATUS.REATTEMPT || Props.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION
            ? "#B42318"
            : "#667085"
        }
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 15L12.5 10L7.5 5"
      />
    </svg>
  ) : Props.component === "codingPageLearnerSideBreadCrumbs" ? (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L5 5L1 1"
        stroke="#344054"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={Props.handleFunction}
      xmlns="http://www.w3.org/2000/svg"
      className={!Props.disabled ? "nextIcon" : "disableNextIcon"}
    >
      <g filter="url(#filter0_d_1929_16774)">
        <rect x="2" y="1" width="20" height="20" rx="10" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          rx="9.5"
          width="19"
          height="19"
          stroke="#D0D5DD"
        />
        <path
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.5 14L13.5 11L10.5 8"
          stroke={!Props.disabled ? "#667085" : "#D0D5DD"}
        />
      </g>
      <defs>
        <filter
          x="0"
          y="0"
          width="24"
          height="24"
          id="filter0_d_1929_16774"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1929_16774"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect1_dropShadow_1929_16774"
          />
        </filter>
      </defs>
    </svg>
  );
}
